import { Translate } from 'react-redux-i18n'
import { useLocation, useNavigate } from 'react-router'
import { Element } from '../../common/html/element'
import { COMPONENTS } from '../../routers/constants'
import classes from './index.module.scss'

const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const notificationsSettingRoute =
    COMPONENTS.systemNotifications.components.systemNotificationsSettings.route
  const isSettingsPage = location.pathname === notificationsSettingRoute

  const redirectSettingScreen = () => {
    navigate(notificationsSettingRoute)
  }

  return (
    <Element
      className={[
        'flexRow justifyContentBetween alignItemsCenter',
        classes.header,
      ].join(' ')}
      style={{
        borderBottomColor: '#e5e5e8',
      }}
    >
      <Element
        className={classes.title}
        style={{
          fontSize: 24,
          color: '#0553A5',
        }}
      >
        <Translate
          value={
            isSettingsPage
              ? 'systemNotifications.NOTIFICATION_SETTINGS'
              : 'systemNotifications.NOTIFICATIONS'
          }
        />
      </Element>
      {!isSettingsPage && (
        <Element
          className="cursorPointer"
          style={{ color: '#2C73E8' }}
          onClick={redirectSettingScreen}
        >
          <Translate value="systemNotifications.NOTIFICATION_SETTINGS" />
        </Element>
      )}
    </Element>
  )
}

export default Header
